"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
exports.colors = {
  transparent: 'transparent',
  black: '#000000',
  white: '#ffffff',
  graphColors: ['#22AA5F', '#52D28C', '#05964B', '#074A25', '#009CC4', '#66C4DC', '#B3E2EE', '#F18700', '#F7B766', '#FBDBB3'],
  primary: {
    red: '#CA1234',
    darkRed: '#A3162C',
    green: '#22AA5F',
    mediumGreen: '#008C3D',
    darkGreen: '#005E2E'
  },
  secondary: {
    lightGrey: '#D9E1E2',
    mediumGrey: '#A4BCC2',
    grey: '#425563',
    darkGrey: '#253645',
    vDarkGrey: '#1A2834'
  },
  status: {
    warning: '#F18700',
    warning10: 'rgba(241, 135, 0, .1)',
    info: '#009CC4',
    info10: 'rgba(0, 156, 196, .1)',
    error: '#CA1234',
    error10: 'rgba(202, 18, 52, .1)',
    success: '#22AA5F',
    success10: 'rgba(18, 202, 100, .1)'
  },
  actions: {
    primary: '#22AA5F',
    secondary: '#425563',
    whiteStateHover: '#F8FAFC',
    whiteStateActive: '#D9E1E2',
    greenStateHover: '#0D8E46',
    darkGreenStateActive: '#075128',
    greenStateDisabled: '#89E5B2',
    greyStateHover: '#425563',
    greyStatePrimaryHover: '#A4BCC2',
    darkGreyStateHover: '#1A2228',
    darkGreyStateDisabled: '#9CA7AE',
    greenTextColorDisabled: '#97E7BB',
    greyTextColorDisabled: '#BEC6CA'
  },
  graphical: {
    strokes: '#E3E6E8',
    darkStrokes: '#253645',
    bgLightGrey: '#F8FAFC',
    bgMediumGrey: '#E8EEEF',
    bgDarkGrey: '#425563'
  },
  shades: {
    strokes: '#E3E6E8',
    bgLightGrey: '#F8FAFC',
    bgLightGren: '#E8FAF0',
    fontDarkGrey: '#425563'
  }
};